import { useRef, useState } from "react";
import Slider, { Settings } from "react-slick";
import { Box, Container, IconButton, makeStyles, useMediaQuery } from "@material-ui/core";

import { fontFamily } from "../../../../app/theme";
import { CustomerSliderType } from "../../quoteDetail.constants";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

export const CustomerSay = ({ customerSlider }: { customerSlider: CustomerSliderType[] }) => {
  const classes = useCustomerSayStyles(customerSlider.length)();
  const [activeSlide, setActiveSlide] = useState<number>(0);
  const settings: Settings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    className: classes.slider,
    autoplay: true,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    autoplaySpeed: 30000,
    beforeChange: (_current, next) => setActiveSlide(next)
  };
  const customerSliderRef = useRef<Slider>(null);

  const isMoreThan1024 = useMediaQuery("(min-width: 1025px)");
  const { isMoreThanMd, isMoreThanSm } = useBreakpoint();

  return (
    <Box position={"relative"}>
      <Container maxWidth="lg">
        <Box className={classes.box}>
          <Box className={classes.boxClipPath}>
            <Box
              className={classes.boxContent}
              p={isMoreThanMd ? "54px 100px 90px 100px" : isMoreThanSm ? "54px" : "30px 55px 61px 55px"}
            >
              <Box
                display={"flex"}
                alignItems={"center"}
                pb={isMoreThanSm ? "55px" : "30px"}
                justifyContent={"space-between"}
              >
                <Box>
                  <Box
                    fontSize={isMoreThanSm ? "18px" : "10px"}
                    lineHeight={isMoreThanSm ? 2.11 : 3.8}
                    color={"#f7815c"}
                    style={{ textTransform: "uppercase" }}
                  >
                    12,500+ installations completed to date
                  </Box>
                  <Box
                    fontSize={isMoreThanSm ? "32px" : "20px"}
                    color={"#fff"}
                    letterSpacing={isMoreThanSm ? "1.49px" : "0.5px"}
                    lineHeight={isMoreThanSm ? 0.75 : 1.2}
                  >
                    What our customers say
                  </Box>
                </Box>
                {isMoreThanMd && (
                  <Box display={"flex"} zIndex={10} alignItems={"center"} pr="35px">
                    <IconButton
                      color="primary"
                      className={`${classes.btnSlider}`}
                      onClick={() => customerSliderRef.current?.slickPrev()}
                    >
                      <img loading="lazy" src={"images/arrow_down.svg"} alt="arrow_left" style={{ rotate: "90deg" }} />
                    </IconButton>
                    <IconButton
                      color="primary"
                      className={`${classes.btnSlider}`}
                      onClick={() => customerSliderRef.current?.slickNext()}
                    >
                      <img loading="lazy" src={"images/arrow_down.svg"} alt="arrow_left" style={{ rotate: "-90deg" }} />
                    </IconButton>
                    {isMoreThanMd && <Box width={"180px"} height={"3px"} />}
                  </Box>
                )}
              </Box>
              <Slider {...settings} ref={customerSliderRef}>
                {customerSlider.map((item, idx) => (
                  <Box width={"100%"} key={idx}>
                    <Box display={"flex"} alignItems={"start"} justifyContent={"space-between"}>
                      <Box paddingRight={isMoreThanMd ? "80px" : 0}>
                        <img src={"images/quote.svg"} alt={item.customerName} height={isMoreThanSm ? "auto" : "21px"} />

                        {!isMoreThanMd && (
                          <Box mt={"16px"}>
                            <img
                              src={item.customerImage}
                              alt={item.customerName}
                              width={"100%"}
                              style={{ objectFit: "contain" }}
                            />
                          </Box>
                        )}
                        <Box
                          mt={isMoreThanSm ? "24px" : "16px"}
                          fontSize={isMoreThan1024 ? "18px" : isMoreThanSm ? "16px" : "14px"}
                          lineHeight={2}
                          color={"#fff"}
                        >
                          {item.customerMessage}
                        </Box>
                        <Box
                          mt={"24px"}
                          fontSize={isMoreThan1024 ? "20px" : isMoreThanSm ? "16px" : "14px"}
                          lineHeight={1.2}
                          color={"#fff"}
                          style={{ textTransform: "uppercase" }}
                        >
                          <div dangerouslySetInnerHTML={{ __html: item.customerName }} />
                        </Box>
                      </Box>
                      {isMoreThanMd && (
                        <Box>
                          <img
                            src={item.customerImage}
                            alt={item.customerName}
                            width={isMoreThan1024 ? "397px" : "300px"}
                            height={"313px"}
                            style={{ objectFit: "contain" }}
                          />
                        </Box>
                      )}
                    </Box>
                  </Box>
                ))}
              </Slider>
            </Box>
          </Box>
        </Box>
      </Container>

      {!isMoreThanMd && (
        <>
          <Box position={"absolute"} top={"48%"} left={"0px"} zIndex={100}>
            <IconButton
              color="primary"
              className={classes.btnSlider}
              onClick={() => customerSliderRef.current?.slickPrev()}
            >
              <img loading="lazy" src={"images/arrow_down.svg"} alt="arrow_left" style={{ rotate: "90deg" }} />
            </IconButton>
          </Box>
          <Box position={"absolute"} top={"48%"} right={"0px"} zIndex={100}>
            <IconButton
              color="primary"
              className={`${classes.btnSlider} m-0`}
              onClick={() => customerSliderRef.current?.slickNext()}
            >
              <img loading="lazy" src={"images/arrow_down.svg"} alt="arrow_left" style={{ rotate: "-90deg" }} />
            </IconButton>
          </Box>
          <Box
            display={"flex"}
            position={"absolute"}
            bottom={"-22px"}
            width={"100%"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            {customerSlider.map((_item, idx) => (
              <Box
                key={idx}
                width={"68px"}
                height={"3px"}
                bgcolor={activeSlide === idx ? "#f7815c" : "#706483"}
                mr={idx === 0 ? "8px" : 0}
              />
            ))}
          </Box>
        </>
      )}
    </Box>
  );
};

const useCustomerSayStyles = (slideLength: number) =>
  makeStyles((theme) => ({
    box: {
      maxWidth: "1170px",
      width: "100%",
      height: "auto",
      borderRadius: 4,
      position: "relative",
      margin: "0 auto",
      filter: "drop-shadow(0px 5px 5px rgba(0, 0, 0, 0.07)) drop-shadow(0px 10px 15px rgba(50, 50, 93, 0.1))",

      [theme.breakpoints.down(600)]: {
        minHeight: "424px"
      },
      [theme.breakpoints.up("md")]: {
        height: "570px"
      }
    },
    boxClipPath: {
      maxWidth: "1170px",
      width: "100%",
      height: "auto",
      filter: "url(#round)",

      [theme.breakpoints.down(600)]: {
        minHeight: "424px"
      },
      [theme.breakpoints.up("md")]: {
        height: "570px"
      }
    },
    boxContent: {
      maxWidth: "1170px",
      width: "100%",
      height: "auto",
      background: "#160337",
      clipPath: "polygon(calc(100% - 90px) 0, calc(100% - 90px) 90px, 100% 90px, 100% 100%, 0 100%, 0 0)",
      [theme.breakpoints.down("sm")]: {
        clipPath: "polygon(calc(100% - 45px) 0, calc(100% - 45px) 45px, 100% 45px, 100% 100%, 0 100%, 0 0)"
      },
      [theme.breakpoints.down(600)]: {
        minHeight: "424px"
      },
      [theme.breakpoints.up("md")]: {
        height: "570px"
      }
    },
    slider: {
      "& .slick-dots": {
        top: "-93px",
        right: "35px",
        width: "fit-content",
        [theme.breakpoints.down(956)]: {
          display: "none !important"
        }
      },
      "& .slick-dots li": {
        width: slideLength === 1 ? "180px" : slideLength === 2 ? "90px" : "60px",
        height: "3px",
        background: "#706483",
        margin: 0
      },
      "& .slick-dots li.slick-active": {
        background: "#f7815c"
      }
    },
    btnSlider: {
      "padding": 0,
      "background": "#f7815c",
      "width": "47px",
      "height": "47px",
      "marginRight": "14px",
      "&:hover": {
        background: "#f7815c"
      },
      "&.m-0": {
        marginRight: "0px !important"
      },
      "& .MuiButton-label": {
        borderBottom: "2px solid #f7815c",
        color: "#f7815c",
        fontFamily: fontFamily.Axiforma,
        fontWeight: 400,
        lineHeight: 1
      }
    }
  }));
